<app-sg-aria-message [errorMessageModelArray]="errorMessageModelArray" *ngIf="isErrMssageDisplay"></app-sg-aria-message>
<h1>入金突合明細画面</h1>
<form [formGroup]="parentForm" (ngSubmit)="regist()">

    <!-- 基本情報 -->
    <app-sgke130d-basic-info *ngIf="basicInfo" [basicInfo]="basicInfo">
    </app-sgke130d-basic-info>

    <!-- 突合結果 -->
    <app-sgke130d-reconciliation-result *ngIf="reconciliationResult" [reconciliationResult]="reconciliationResult">
    </app-sgke130d-reconciliation-result>

    <!-- 入金予定明細 -->
    <app-sgke130d-receivemoneyyotei-meisai *ngIf="receivemoneyyoteiMeisaiList"
        [receivemoneyyoteiMeisaiList]="receivemoneyyoteiMeisaiList">
    </app-sgke130d-receivemoneyyotei-meisai>

    <!-- 口座入金報告明細 -->
    <app-sgke130d-kouza-depositreport-meisai *ngIf="kouzaDepositreportMeisai" [mode]="mode" [basicInfo]="basicInfo"
        [kouzaDepositreportMeisai]="kouzaDepositreportMeisai"
        (onClickAmountRegistEmitter)="navigateToNoticeReportOnClickRegist(false)"
        (onClickAmountEditEmitter)="navigateToNoticeReportOnClickRegist(true)">
    </app-sgke130d-kouza-depositreport-meisai>

    <!-- 入金手数料明細 -->
    <app-sgke130d-rcvmny-fee-meisai *ngIf="rcvmnyFeeMeisai" [mode]="mode" [basicInfo]="basicInfo"
        [rcvmnyFeeMeisai]="rcvmnyFeeMeisai" (onClickFeeRegistEmitter)="navigateToFeeReportOnClickRegist(false)"
        (onClickFeeEditEmitter)="navigateToFeeReportOnClickRegist(true)">
    </app-sgke130d-rcvmny-fee-meisai>

    <!-- 備考欄 -->
    <app-sgke130d-bikoran *ngIf=" bikoran" [mode]="mode" [basicInfo]="basicInfo" [bikoran]="bikoran">
    </app-sgke130d-bikoran>

    <div class="tw-flex tw-flex-col tw-box-border tw-justify-start tw-items-center tw-content-center">
        <mat-card-actions style="margin: 0 7% 0 auto;">
            <button *ngIf="mode != MODE_APPROVE " type="submit" mat-raised-button color="primary" class="btn"
                [disabled]="isReportButtonDisabled()">報告</button>
            <button *ngIf="mode == MODE_APPROVE" type="submit" mat-raised-button color="primary" class="btn"
                [disabled]="isApproveButtonDisabled()">承認</button>
        </mat-card-actions>
        <mat-card-actions style="margin: 0 7% 0 auto;">
            <button type="button" mat-raised-button color="primary" class="btn" (click)="goToPrevious()">キャンセル</button>
        </mat-card-actions>
    </div>

</form>